__turbopack_context__.v({
  "action-button-wrapper": "styles-module__lDRN0W__action-button-wrapper",
  "dialogIconBadge": "styles-module__lDRN0W__dialogIconBadge",
  "feed-item-wrapper": "styles-module__lDRN0W__feed-item-wrapper",
  "feedItemDialog": "styles-module__lDRN0W__feedItemDialog",
  "feeditem-menu-actions": "styles-module__lDRN0W__feeditem-menu-actions",
  "icon-badge-span": "styles-module__lDRN0W__icon-badge-span",
});
